import Button from './Button';

export default Button;



// WEBPACK FOOTER //
// ./src/components/atoms/Button/index.js